import type { ReservationListItem } from '../../../services/reservationsApi';

export interface ReservationDashboardStats {
  totalCount: number;
  approvedCount: number;
  pendingCount: number;
  consumedCount: number;
}

export const filterPendingReservations = (
  rows: ReservationListItem[]
): ReservationListItem[] => rows.filter((item) => item.status === 'Pending');

export const filterConsumedReservations = (
  rows: ReservationListItem[]
): ReservationListItem[] => rows.filter((item) => item.status === 'Consumed');

export const computeReservationDashboardStats = (
  rows: ReservationListItem[]
): ReservationDashboardStats => {
  const totalCount = rows.length;
  const approvedCount = rows.filter((item) => item.status === 'Approved').length;
  const pendingCount = filterPendingReservations(rows).length;
  const consumedCount = filterConsumedReservations(rows).length;
  return { totalCount, approvedCount, pendingCount, consumedCount };
};
